import {Component, Inject} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef
} from '@angular/material/dialog';
import {Opportunity} from '../../interfaces/opportunity.interface';
import {OpportunityService} from '../../services/opportunity.service';
import {UntypedFormGroup} from '@angular/forms';
import {FollowUp} from '../../interfaces/follow-up.interface';
import {DataService} from '../../../services/data.service';
import {FollowUpFormComponent} from '../follow-up-form/follow-up-form.component';
import {MatButton} from '@angular/material/button';



@Component({
    selector: 'app-follow-up-edit',
    imports: [
        FollowUpFormComponent,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        MatDialogContent
    ],
    templateUrl: 'follow-up-edit-dialog.component.html'
})
export class FollowUpEditDialogComponent {

    formGroup: UntypedFormGroup;
    saving = false;

    constructor(
        private dialogRef: MatDialogRef<FollowUpEditDialogComponent>,
        private opportunityService: OpportunityService,
        @Inject(MAT_DIALOG_DATA) public data: { followUp: FollowUp, opportunity: Opportunity },
        private dataService: DataService
    ) {
        this.formGroup = this.opportunityService.getEmptyFollowUpForm();
    }

    save() {
        this.saving = true;
        const formValue: FollowUp = this.formGroup.getRawValue();
        this.opportunityService.updateForecastAmountsValue(formValue);
        this.opportunityService.transformDatesBeforeSave(formValue);
        this.dataService.editFollowUp(formValue).then(() => {
            console.log('Follow-up successfully edited');
            this.saving = false;
            this.dialogRef.close();
        }).catch(error => {
            console.error('Error creating follow-up: ', error);
            this.saving = false;
        });
    }
}